<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-close="close" vm-size="medium" @vm-accept="saveRecords" :vm-buttons-hidden="false" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="true" :vm-active="isModalReceptionVisible" :vm-title='getTitle')
    vm-table(max-height="500px" :data="receptionsDetails")
      template(slot="header")
        .d-flex.justify-content-between
      template(slot="thead")
        vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_orders_detail.' + column) }}
      template(slot-scope="{data}")
        vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
          vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
            slot(v-if="column == 'product'") {{data[indextr][column]['name']}}
            .input__wrapper(v-if="column == 'received_quantity'")
              vm-input(class="mx-auto" autofocus :disabled="only_read" v-model="data[indextr]['received_quantity']" @blur="checkValue(data[indextr])" @keyup="checkValue(data[indextr])" @keypress="checkValue(data[indextr])" style="width:100px;")
            slot(v-if="column == 'actions' && $auth.check('Admin')")
              .actions__wrapper
                vm-button(type="flat" icon="trash-2-outline" color="#026481" @click="deleteReceptionConfirm(data[indextr], tr)")
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Receptions')

export default {
  name: 'ModalReception',
  props: {
    id: {
      type: Number,
      default: null
    },
    shipment: {
      type: String,
      default: null
    },
    purchase_order_detail_id: {
      type: Number,
      default: null
    },
    only_read: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    columns: [
      'product',
      'received_quantity',
      'actions'
    ]
  }),
  validations: {},
  computed: {
    ...mapGetters([
      'isModalReceptionVisible',
      'receptionsDetails'
    ]),
    getTitle () {
      return this.$t('strings.edit')
    }
  },
  watch: {
    isModalReceptionVisible (flag) {
      if (flag) {
        if (this.shipment !== '0x') {
          this.loadReceptionsDetails({ supplier_shipment_detail_id: this.id })
        } else {
          this.loadReceptionsDetails({ supplier_shipment_detail_id: this.id, purchase_order_detail_id: this.purchase_order_detail_id })
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalReceptionVisible',
      'loadReceptionsDetails',
      'deleteReception',
      'loadRecords',
      'updateReception',
      'loadPurchaseOrder'
    ]),
    async deleteReceptionConfirm (reception) {
      this.auxDeleteReception = () => {
        this.deleteReception({ purchase_order_id: this.$route.params.id, supplier_shipment_id: reception.supplier_shipment_id, reception_id: reception.id, data: reception }).then(() => {
          this.loadRecords({ purchase_order_id: this.$route.params.id, supplier_shipment_id: this.shipment }).then(() => {
            this.loadPurchaseOrder({ id: this.$route.params.id })
          })
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.reception'), attribute: this.$t(reception.product.name) }),
        accept: this.auxDeleteReception
      })
    },
    checkValue (data) {
      const ReceivedQuantity = data.received_quantity
      const LimitToReceived = data.limit_to_received
      if (parseFloat(ReceivedQuantity) > parseFloat(LimitToReceived)) data.received_quantity = parseFloat(LimitToReceived)
    },
    async saveRecords () {
      await this.updateReception({ purchase_order_id: this.receptionsDetails[0].purchase_order_id, supplier_shipment_id: this.shipment, reception_id: this.receptionsDetails[0].id, data: this.receptionsDetails }).then(() => {
        this.loadRecords({ purchase_order_id: this.$route.params.id, supplier_shipment_id: this.shipment }).then(() => {
          this.loadPurchaseOrder({ id: this.$route.params.id })
        })
      })
    },
    close () {
      this.setModalReceptionVisible(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
